'use strict';

var idx = function idx(p, obj) {
  return p.reduce(function (a, b) {
    return a && a[b] ? a[b] : null;
  }, obj);
};

var px = function px(n) {
  return n ? n + 'px' : n;
};

var radius = function radius(n) {
  return function (arg) {
    if (typeof arg === 'number') return arg;

    switch (arg) {
      case true:
        return n;
      case 'top':
        return [n, n, 0, 0].map(px).join(' ');
      case 'right':
        return [0, n, n, 0].map(px).join(' ');
      case 'bottom':
        return [0, 0, n, n].map(px).join(' ');
      case 'left':
        return [n, 0, 0, n].map(px).join(' ');
      case false:
        return 0;
      default:
        return null;
    }
  };
};

module.exports = {
  idx: idx,
  radius: radius
};


//////////////////
// WEBPACK FOOTER
// ./~/axs/dist/util.js
// module id = 28
// module chunks = 0